export default {
  buttons: {
    reschedule: 'Reagendar',
    'reschedule-change-address': 'Reagendar/Alterar endereço',
    'add-time': 'Adicionar horário',
  },
  'pickup-time-min-title': 'Horário de retirada mín.',
  'pickup-time-max-title': 'Horário de retirada máx.',
  'pickup-date': 'Escolha uma data de entrega',
  'change-address': {
    title: 'Você alterou seu endereço',
    description: 'Aguarde um pouco enquanto processamos seu pedido; enviaremos o link de rastreamento.',
    error: 'Desculpe, não entregamos no endereço selecionado. Informe outro endereço.',
  },
  'coolbox-modal': {
    message: 'Seu medicamento tem uma restrição de entrega sensível ao tempo.<br>Tem certeza de que deseja reagendar a data de entrega?',
    rescheduleButton: 'Sim, reagendar',
    cancelButton: 'Cancelar',
  },
  'next-day-window': 'Dia seguinte 8:00–21:00',
}
